
export const VERSION = '5.4.1'; // Update this manually on each release

